import React, { useState } from "react";
import "./Style/RecentView.scss";
import { NoContent } from "./icons/Icons";
import RecentlyViewedData from "./RecentlyViewedData";

// Component to render the "Recently Viewed" section
const RecentView = ({ recentViewData = [] }) => {
  // Fallback to empty array if recentViewData is undefined or null
  const items = recentViewData || [];

  return (
    <div className="recentview-container">
      {/* Section title */}
      <p>RECENTLY VIEWED</p>

      <div className="recently-viewed-content">
        {/* If there are no items, show a placeholder image and message */}
        {items.length === 0 ? (
          <div className="contentimg">
            <img
              src={
                "https://tbr-ggk.s3.us-east-2.amazonaws.com/production/open_search_assets/nosearchhistory_os_icon.svg"
              }
              alt="nocontent"
            />
            <div className="nohistory-label">No Search History</div>
          </div>
        ) : (
          // Otherwise, render the recently viewed items
          <RecentlyViewedData items={items} />
        )}
      </div>
    </div>
  );
};

export default RecentView;
